<script lang="ts">
 import Breadcrumb from "$lib/Breadcrumb.svelte";
  import MetaData from "$lib/MetaData.svelte";
  import { contentBlockComponents } from "$lib/portableText/utils";
  import { PortableText } from "@portabletext/svelte";
  import type { PortableTextBlock } from "@portabletext/types";

  interface Props {
    data: {
    skjemaer: {
      title: string;
      description: string;
      content: PortableTextBlock[];
    };
  };
  }

  let { data }: Props = $props();
  let skjemaer = $derived(data?.skjemaer);
</script>

<MetaData
  data={{
    title: skjemaer?.title,
    description: "Her finnes ulike skjemaer du som kunde kan ha nytte av.",
  }}
/>

<Breadcrumb
  breadcrumbs={[
    { label: "Forside", href: "/" },
    { label: "Skjemaer", href: "/privat/skjema" },
  ]}
/>
<section class="mx-$space-edge-x">
  <h1>{skjemaer?.title}</h1>
  <div class="prose">
    <p>{skjemaer?.description}</p>
    <p>
      <a class="button button-primary" href="/privat/kundeservice">Kundeservice</a>
    </p>
    <div class="schema-list">
      <PortableText
        value={skjemaer?.content}
        components={contentBlockComponents}
        onMissingComponent={false}
      />
    </div>
  </div>
</section>

<style lang="postcss">
  .schema-list :global(ul) {
    list-style: none;
  }

  .schema-list :global(:where(ul, h2)) {
    padding: 0;
  }
  .schema-list :global(li) {
    padding-block-start: var(--s-3);
  }
</style>
